import React from 'react';
import { termsConfig } from '../../../config/terms.config.js';
export const legalEntityAgreementContent = {
  title: "об использовании материалов и сервисов интернет-сайта https://svetofore.com/",
  text: termsConfig.terms_of_use_text,
  checkboxText: "Я принимаю условия пользовательского соглашения",
};
